// --- Documents ---

export enum DocumentTagID {
  Funding = 'funding',
  FindCare = 'find_care',
  PowerOfAttorney = 'power_of_attorney',
  CallNotes = 'call_notes',
  Onboarding = 'onboarding',
}

export const isCallNoteTag = (tagId: string): boolean =>
  tagId === DocumentTagID.CallNotes;

export const isCallNoteDocument = (tags?: OrganiseDocumentTag[]): boolean =>
  tags?.some((t) => isCallNoteTag(t.id)) ?? false;

export enum OrganiseDocumentStatus {
  Pending = 'pending',
  Scanning = 'scanning',
  Scanned = 'scanned',
  Rejected = 'rejected',
}

export interface OrganiseDocumentTag {
  id: string;
  name: string;
}

export interface OrganiseDocument {
  id: string;
  careCircleId: string;
  uploaderAccountId: string;
  title: string;
  description?: string | null;
  filename: string;
  contentType: string;
  sizeBytes: number;
  status: OrganiseDocumentStatus;
  uploadExpiresAt?: string | null;
  confirmedAt?: string | null;
  scanStartedAt?: string | null;
  scanFinishedAt?: string | null;
  scanResult?: string | null;
  scanError?: string | null;
  extractedAt?: string | null;
  tags?: OrganiseDocumentTag[];
  createdAt: string;
  updatedAt: string;
}

export interface OrganiseDocumentWithDownloadURL extends OrganiseDocument {
  downloadUrl: string;
}

export interface RequestDocumentUploadURLRequest {
  title: string;
  description?: string | null;
  filename: string;
  contentType: string;
  sizeBytes: number;
  tags?: string[];
}

export interface RequestDocumentUploadURLResponse {
  documentId: string;
  uploadUrl: string;
  expiry: string;
}

export interface ConfirmDocumentUploadRequest {
  documentId: string;
}

export interface LinkDocumentToEntryRequest {
  entryId: string;
  calendarId: string;
  action: 'link' | 'unlink';
}

export interface UpdateDocumentRequest {
  title: string;
  description?: string | null;
  filename: string;
  contentType: string;
  sizeBytes: number;
}

export interface UpdateDocumentResponse {
  documentId: string;
  uploadUrl: string;
  expiry: string;
}

// --- Call Notes ---

export const CallStatus = {
  Upcoming: 'upcoming',
  Past: 'past',
} as const;
export type CallStatus = (typeof CallStatus)[keyof typeof CallStatus];

/** Content structure for call note documents fetched from downloadUrl. */
export interface CallNoteContent {
  title: string;
  content: unknown;
  createdAt: string;
}
